export default __webpack_public_path__ + "static/media/ser4.108a6050.jpg";